module.exports = __webpack_public_path__ + "media/public/images/social/telegram-ce92df75f3be5478cd322d3cc3048c4a.svg";